import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-clipboard-text"]

import ClipboardJS from 'clipboard';
import { ElMessage } from 'element-plus'

// 定义emit

export default /*#__PURE__*/_defineComponent({
  __name: 'CopyView',
  props: {
  text: {
    type: String,
    default: ''
  }
},
  emits: ['successCallback', 'errorCallback'],
  setup(__props, { emit: __emit }) {

const emit = __emit

// 定义props
const props = __props

/**
 * 复制链接
 */
const copyLink = () => {
  const clipboard = new ClipboardJS('.copy-link')
  clipboard.on('success', () => {
    ElMessage.success('复制成功');
    emit('successCallback');
    clipboard.destroy()
  })
  clipboard.on('error', () => {
    ElMessage.error('复制失败');
    emit('errorCallback');
    clipboard.destroy()
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "copy-link cursor-pointer",
    "data-clipboard-text": __props.text,
    onClick: copyLink
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})